import React from 'react';

import type { ListType } from '~/components-ds/ReviewList';
import ReviewList from '~/components-ds/ReviewList';
import { COVER_DETAILS_MONEY_ROUTE } from '~/constants/routes';
import { useAppContent, useCoverDetails } from '~/hooks';
import { Cover } from '~/types/cover';
import { CurrencyFormat, currencyFormatter } from '~/utils/currencyFormatter';

const ReviewMoney: React.FC = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.review.fields.money' });

  const { moneySI } = useCoverDetails();
  const moneyReviewList = [
    {
      label: getTextContent('sumInsured'),
      data: currencyFormatter(moneySI, CurrencyFormat.Comma),
    },
  ];

  return (
    <ReviewList
      list={
        moneyReviewList.reduce(
          (prev, curr, idx) => ({
            ...prev,
            [String(idx)]: {
              id: idx,
              name: curr.label,
              label: curr.label,
              value: curr.data,
            },
          }),
          {}
        ) as ListType
      }
      title={Cover.Money}
      editRoute={COVER_DETAILS_MONEY_ROUTE}
    />
  );
};

export default ReviewMoney;
